import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

window.React = React;

window.addEventListener('error', (e) => {
  console.error("Critical module error caught:", e.error || e);
  const stack = e.error && e.error.stack ? e.error.stack : 'No stack trace available';
  document.body.innerHTML = `<div style="background:red;color:white;padding:20px;font-family:sans-serif;word-break:break-word">
    <h1>CRITICAL MODULE ERROR</h1>
    <pre style="font-size:16px;font-weight:bold">${e.message}</pre>
    <pre style="background:rgba(0,0,0,0.3);padding:15px;overflow:auto;max-height:500px;font-size:12px;white-space:pre-wrap;border-radius:4px">${stack}</pre>
    <button onclick="localStorage.clear(); location.reload()" style="background:white;color:black;padding:10px;border:none;border-radius:5px;font-weight:bold;cursor:pointer">Clear Cache & Reload</button>
  </div>`;
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
